import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CHEVRON_DOWN, CHEVRON_LEFT, CHEVRON_RIGHT_WHITE } from "../../assets";
import ButtonV2 from "../../shared/components/buttonV2";
import TableComponent from "../../shared/components/table";
import { TableData } from "../../constants";
import { CauseListColumn } from "../../shared/components/table/columns";

function CauseList() {
  return (
    <LandingPageLayout title={<>Cause List </>} currentLink="Cause List">
      <div className="px-4 sm:px-8 lg:px-20 py-6 sm:py-8 w-full flex flex-col gap-y-6 sm:gap-y-8">
        <span className="text-xl sm:text-2xl font-bold text-primary-300">
          Cause List{" "}
        </span>

        <div className="w-full flex flex-col lg:flex-row items-start lg:items-center gap-y-4 lg:gap-y-0 lg:gap-x-3">
          <div className="w-full flex flex-col gap-y-2 relative">
            <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
              Division
            </span>
            <div
              //   onClick={() => setDropdowns({ ...dropdowns, userType: true })}
              className="flex items-center justify-between gap-x-3 px-3 py-2 cursor-pointer rounded-xl border border-borderColor shadow-box"
            >
              <input
                type="text"
                placeholder="Select Division"
                className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-xs sm:placeholder:text-sm placeholder:text-[#808080] text-sm"
              />

              <img
                src={CHEVRON_DOWN}
                className="w-[18px] sm:w-[20px] h-[18px] sm:h-[20px]"
                alt="Dropdown"
              />
            </div>
          </div>
          <div className="flex flex-col gap-y-2 w-full">
            <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
              Appeal No.
            </span>
            <input
              type="text"
              name="appealNo"
              className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent px-3 py-2 text-sm"
              placeholder="Enter appeal No."
            />
          </div>
          <div className="flex flex-col gap-y-2 w-full">
            <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
              Parties
            </span>
            <input
              type="text"
              name="parties"
              className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent px-3 py-2 text-sm"
              placeholder="Enter parties"
            />
          </div>
          <div className="flex flex-col gap-y-2 w-full">
            <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
              Date
            </span>
            <input
              type="date"
              name="date"
              className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent px-3 py-2 text-sm"
            />
          </div>
          <ButtonV2
            btnStyle="w-full lg:w-fit px-4 sm:px-5 py-2 sm:py-2 rounded-3xl gap-2 bg-globalGreen flex items-center justify-center self-end"
            textStyle="text-white font-medium text-xs sm:text-sm"
            title="Search"
            image={CHEVRON_RIGHT_WHITE}
            handleClick={() => {}}
          />
        </div>
        <div className="overflow-x-auto">
          <TableComponent
            DATA={TableData}
            // @ts-ignore
            COLUMNS={CauseListColumn}
          />
        </div>
        <div className="flex items-center justify-center space-x-3 sm:space-x-5">
          <button
            type="button"
            onClick={() => {}}
            className={`border border-[#EBEBEB] rounded-xl w-[35px] sm:w-[40px] h-[35px] sm:h-[40px] lg:flex hidden items-center gap-x-2 justify-center`}
          >
            <img
              src={CHEVRON_LEFT}
              className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px]"
              alt="Previous"
            />
          </button>
          <div
            className={`flex items-center gap-x-1 sm:gap-x-2 ${
              [1, 2, 3, 4, 5, 6].length > 5 &&
              "max-w-[180px] sm:max-w-[200px] overflow-x-auto"
            }`}
          >
            {[1, 2, 4, 5, 6, 7].map((page: any, index: number) => (
              <button
                key={index}
                className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGreen hover:text-white transition-all duration-300 gap-x-2 min-w-[35px] sm:min-w-[40px] h-[35px] sm:h-[40px] rounded-xl ${
                  page.active
                    ? "bg-globalGreen text-white"
                    : "border text-[#2A2E34]"
                } `}
              >
                <span className={`text-[11px] sm:text-[13px]`}>{page}</span>
              </button>
            ))}
          </div>
          <button
            type="button"
            className={`border border-[#EBEBEB] rounded-xl gap-x-2 w-[35px] sm:w-[40px] h-[35px] sm:h-[40px] lg:flex hidden items-center justify-center`}
          >
            <img
              src={CHEVRON_LEFT}
              className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px] scale-x-[-1]"
              alt="Next"
            />
          </button>
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default CauseList;
